/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Segment_Event_Group_Action_NameInputs */



/**
* | output |
* | --- |
* | "segment event group" |
*
* @param {Segment_Event_Group_Action_NameInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const segment_event_group_action_name = /** @type {((inputs?: Segment_Event_Group_Action_NameInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Segment_Event_Group_Action_NameInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("segmenter le groupe d'evenements")
	if (locale === "de") return /** @type {LocalizedString} */ ("Segment-Ereignisgruppe")
	if (locale === "it") return /** @type {LocalizedString} */ ("gruppo di eventi del segmento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("сегмент группы событий")
	if (locale === "es") return /** @type {LocalizedString} */ ("grupo de eventos de segmento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("细分事件组")
	if (locale === "ja") return /** @type {LocalizedString} */ ("セグメントイベントグループ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("खंड घटना समूह")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("grupo de eventos de segmento")
	return /** @type {LocalizedString} */ ("segment event group")
});